import type { AgentTool } from '@saaga/shared/interfaces/agent-tool.interface'
import type { ReactNode } from 'react'

import { Checkbox } from '@/components/ui/checkbox'
import { CommandItem } from '@/components/ui/command'

export interface ToolSelectorItemProps {
  tool: AgentTool
  isSelected: boolean
  onSelect: (toolId: string) => void
}

export const ToolSelectorItem = ({
  tool,
  isSelected,
  onSelect,
}: ToolSelectorItemProps): ReactNode => (
  <CommandItem key={tool.id} value={tool.id} onSelect={onSelect} className="tool-selector-item">
    <Checkbox checked={isSelected} tabIndex={-1} className="pointer-events-none" />
    <div className="flex flex-col">
      <span className="font-medium">{tool.name}</span>
      <span className="text-xs text-muted-foreground">{tool.description}</span>
    </div>
  </CommandItem>
)

ToolSelectorItem.displayName = 'ToolSelectorItem'
